// The legal copy is imported from the modules the old pages render, so it is
// still edited in one place. Only the presentation changed.
import cookiePolicy from '../../PrivacyPolicy/content/cookiePolicy'
import informationContent from '../../PrivacyPolicy/content/informationContent'
import storageAndSecurity from '../../PrivacyPolicy/content/storageAndSecurity'
import useOfYourData from '../../PrivacyPolicy/content/useOfYourData'
import termsContent from '../../TermsOfUse/content/termsContent'

export const privacyPolicy = {
  eyebrow: 'LEGAL',
  title: 'Privacy Policy',
  intro:
    'The information we learn from customers helps us personalise and continually improve your Entrepreneur Seminar experience. Here are the types of information we gather:',
  parts: [
    { entries: informationContent },
    {
      heading: 'Information Storage and Security',
      entries: [...storageAndSecurity, ...cookiePolicy, ...useOfYourData],
    },
  ],
}

// Copied from Disclaimer.js, which keeps its copy in the component; a rewording
// must change both.
export const disclaimer = {
  eyebrow: 'LEGAL',
  title: 'Earnings and Income Disclaimer',
  parts: [
    {
      entries: [
        {
          paragraphs: [
            'Entrepreneur Insight Limited (“Entrepreneur Seminar”) cannot and does not make any guarantees about your ability to get results or earn any money with our ideas, information, tools, or strategies. You should know that all products and services by our company are for educational and informational purposes only. Nothing on this page, any of our websites, or any of our content or curriculum is a promise or guarantee of results, investment or future earnings, and we do not offer any legal, medical, tax or other professional advice.',
            'Any financial numbers referenced here, or on any of our sites, are illustrative of concepts only and should not be considered average earnings, exact earnings, or promises for actual or future performance. Use caution and always consult your accountant, lawyer or professional advisor before acting on this or any information related to a lifestyle change or your business or finances. You alone are responsible and accountable for your decisions, actions and results in life, and by your registration here you agree not to attempt to hold us liable for your decisions, actions or results, at any time, under any circumstance.',
          ],
        },
      ],
    },
  ],
}

export const termsOfUse = {
  eyebrow: 'LEGAL',
  title: 'Terms of Use',
  intro:
    'Entrepreneur Insight Limited, trading as Entrepreneur Seminar · Company No. 11408037. Last updated: 26 October 2026.',
  parts: [{ entries: termsContent }],
}
